/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

import { getComponentConfig, getComponentElements } from "@/utils/dom/component";

export function initMenu() {
    getComponentElements(Menu.selector).forEach(element => new Menu(element));
}

export class Menu {
    static selector = 'menu';

    static defaults: Partial<MenuOptions> = {
        activeClass: 'current',
        topLevelItemSelector: 'nav > ul > li'
    };

    public element: HTMLElement;
    public config: MenuOptions;

    constructor(element: HTMLElement, options: Partial<MenuOptions> = {}) {

        this.element = element;
        this.config = {
            ...Menu.defaults,
            ...getComponentConfig(Menu.selector, this.element),
            ...options
        };

        this._setActiveLinks();
    }

    /**
     * Destroy instance
     */
    public destroy(): void {
        this.element = null as any;
    }

    /**
     * Set active links
     */
    private _setActiveLinks() {
        const url = window.location.href.split('?')[0].replace(/\/$/, '');
        let parent: HTMLElement | null;

        this.element.querySelectorAll<HTMLElement>(`a[href="${url}"], a[href="${url}/"]`)
            .forEach(link => {
                link.parentElement!.classList.add(this.config.activeClass);

                parent = link.closest(this.config.topLevelItemSelector);
                parent?.classList.add(this.config.activeClass);
            });
    }
}

export interface MenuOptions {
    activeClass: string
    topLevelItemSelector: string
}

export interface MenuEvents {}
